export type { StorageManagerResParams } from './types';

export { default as StorageManager } from './StorageManager';
export { StorageManagerDriver } from './types';
